<template>
  <div id="churn-flow">
    <churn-goodbye-page v-if="!openSurvey" :start-survey="startSurvey"/>
    <churn-survey v-else/>
  </div>
</template>

<script>

import ChurnGoodbyePage from './ChurnGoodbyePage.vue';
import ChurnSurvey from './ChurnSurvey.vue';

export default {
  name: 'ChurnFlow',
  components: {
    ChurnGoodbyePage,
    ChurnSurvey,
  },
  data() {
    return {
      openSurvey: false,
    };
  },
  methods: {
    startSurvey() {
      this.openSurvey = true;
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
